export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker').catch((error) => {
      console.warn('Service worker registration failed:', error)
    })
  })
}
